import { createStore } from 'vuex';
import { IEnterpriseState, IApplicationState, IApiState } from '@/typings/authAudit';
import enterprise from './modules/enterprise';
import application from './modules/application';
import api from './modules/api';
import app from './modules/app';
import user from './modules/user';
import area from './modules/area';
import dict from './modules/dict';
import school from './modules/school';
import factory from './modules/factory';
import frontApp from './modules/frontApp';
import apiManage from './modules/apiManage';
import doc from './modules/doc';
import manageUser from './modules/manageUser';
import { IFactoryState, IUserState } from '@/typings/factory';
import { IFrontApplicationState } from '@/typings/application';
import { IAreaState } from '@/typings/area';
import { IAppState } from '@/typings/app';
import { IDictState } from '@/typings/dict';
import { ISchoolState } from '@/typings/school';
import { IAPIManageState } from '@/typings/apiManage';
import { IDocState } from '@/typings/doc';
import { IManageUserState } from "@/typings/manageUser";

export interface IGlobalState {
    enterprise: IEnterpriseState;
    application: IApplicationState;
    api: IApiState;
    app: IAppState;
    user: IUserState;
    area: IAreaState;
    dict: IDictState;
    school: ISchoolState;
    factory: IFactoryState;
    frontApp: IFrontApplicationState;
    apiManage: IAPIManageState;
    doc: IDocState;
    manageUser: IManageUserState;
}

const store = createStore<IGlobalState>({
    mutations: {
    },
    actions: {
    },
    modules: {
        enterprise,
        application,
        api,
        app,
        user,
        area,
        dict,
        school,
        factory,
        frontApp,
        apiManage,
        doc,
        manageUser
    }
});
export default store;
